import * as React from 'react';
import { useSelector } from 'react-redux';
import { isOffersExperimentEnable } from '../../selectors/offers';
import { OffersBlockContainer } from '../OffersBlock';
import { OffersBlockContainer as OffersBlockAb } from './OffersBlock';

export const OffersBlockABContainer = () => {
  const isABActive = useSelector(isOffersExperimentEnable);

  if (isABActive) {
    return <OffersBlockAb />;
  }

  return <OffersBlockContainer />;
};
